export function pixelToVw(pixel: number, weight: number = 1920): string
{
	return (pixel * 100) / weight + "vw";
}
